export default "__VITE_ASSET__CdyP2DYz__"